/** Member-side prototype exclusions, expressed using the application's paths. */
export function showsFloatingFeedback(pathname: string): boolean {
  return (
    pathname !== '/ei-jasenyytta' &&
    pathname !== '/tunnistus-epaonnistui' &&
    !pathname.startsWith('/messages') &&
    !/^\/jasenedut\/?$/u.test(pathname) &&
    !/^\/(?:admin|cms|login|auth)(?:\/|$)/u.test(pathname)
  );
}
